module.exports = __webpack_public_path__ + "static/img/taide-art-animated.c7e434d.svg";